<template>
  <modal title="הוספת חניך חדש" @close="$emit('close')">
    <div class="main__content" @click.stop>
      <ValidationObserver ref="observer" tag="form" class="flex-grow">
        <div class="popup__body pt-md-4 pb-0 px-md-4 pt-2 px-2">
          <div class="box-white shadow-5 br-1 mb-4">
            <div class="py-md-4 px-md-4 pt-2 px-2">
              <div class="row align-items-start row-mob">
                <div class="col-sm-3 col-mob mb-4 mb-md-0">
                  <UploadImage
                    :imageNotValid="imageNotValid"
                    :imagePreview="imagePreview"
                    :imageError="imageError"
                    :loaderImg="loaderImg"
                    :avatarImgLoaded="avatarImgLoaded"
                    :otherUploadPercentage="otherUploadPercentage"
                    :file="form.main.photo"
                    @change="selectFile"
                    block-title="טען תמונה"
                    block-text="  mb20 הוא   גודל הקובץ המרבי<br />"
                  />
                </div>
                <div class="col-sm-9 col-mob">
                  <div class="row align-items-start row-mob">
                    <div class="col-6 col-mob mb-md-4 mb-2">
                      <div class="form__field form__field--single">
                        <div class="form__field-label">שם פרטי</div>
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="שם פרטי"
                          vid="main.name"
                          rules="required"
                        >
                          <div class="form__field-error">
                            {{ errors[0] }}
                          </div>

                          <input
                            v-model="form.main.name"
                            type="text"
                            :maxlength="36"
                            placeholder="שדה חובה*"
                            :class="
                              'form__field-input ' +
                              (errors[0] ? ' error ' : '')
                            "
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-6 col-mob mb-md-4 mb-2">
                      <div class="form__field form__field--single">
                        <div class="form__field-label">שם משפחה</div>
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="שם משפחה"
                          vid="main.last_name"
                          rules="required"
                        >
                          <div class="form__field-error">
                            {{ errors[0] }}
                          </div>
                          <input
                            v-model="form.main.last_name"
                            type="text"
                            :maxlength="36"
                            placeholder="שדה חובה*"
                            :class="
                              'form__field-input ' +
                              (errors[0] ? ' error ' : '')
                            "
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-6 col-mob">
                      <div class="form__field form__field--single">
                        <div class="form__field-label">תעודת זהות</div>
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="תעודת זהות"
                          :rules="
                            form.main.person_number &&
                            form.main.person_number.length > 0
                              ? 'numeric|digits:9'
                              : ''
                          "
                          vid="main.person_number"
                        >
                          <div class="form__field-error">
                            {{ errors[0] }}
                          </div>

                          <input
                            v-model="form.main.person_number"
                            v-maxlen="36"
                            type="number"
                            value="234567898"
                            :class="
                              'form__field-input ' +
                              (errors[0] ? ' error ' : '')
                            "
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-6 col-mob">
                      <div class="form__field form__field--single">
                        <div class="form__field-label">תאריך לידה</div>
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="תאריך לידה"
                          vid="main.birthday"
                        >
                          <div class="form__field-error">
                            {{ errors[0] }}
                          </div>

                          <vDatepicker
                            :date="form.main.birthday"
                            :error="errors[0]"
                            @change="changeBirthdayDate"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-md-4 px-md-4 mt-2 mt-md-0 py-2 px-2 bgc-grey">
              <div class="row row-mob row-w-sep">
                <div
                  class="
                    col-sm-6 col-mob
                    d-flex
                    align-items-center
                    mb-2 mb-sm-0
                  "
                >
                  <icon name="mobile" class="ml-3 mr-1" />
                  <div class="form__field form__field--single ml-md-4">
                    <!-- <ValidationProvider
                      v-slot="{ errors }"
                      name="מספר טלפון נייד"
                      vid="main.mobile"
                      rules="required|min:9|max:13"
                    >
                      <div class="form__field-error">
                        {{ errors[0] }}
                      </div> -->

                    <input
                      id="mobile-number"
                      v-model="form.main.mobile"
                      placeholder="שדה חובה*"
                      v-maxlen="13"
                      type="number"
                      class="form__field-input"
                    />
                    <!-- </ValidationProvider> -->
                  </div>
                </div>
                <div
                  class="col-sm-6 col-mob d-flex align-items-center"
                  @click.stop
                >
                  <icon name="email" class="ml-md-4 ml-3 mr-1 mr-sm-2" />

                  <div class="form__field form__field--single" @click.stop>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="כתובת מייל"
                      rules="required|email"
                      vid="main.email"
                    >
                      <div class="form__field-error">
                        {{ errors[0] }}
                      </div>
                      <div class="input_email-block" @click.stop>
                        <input
                          v-model="form.main.email"
                          type="email"
                          placeholder="שדה חובה*"
                          :maxlength="100"
                          value="mailtesttext@gmail.com"
                          :class="
                            'form__field-input email-input' +
                            (errors[0] ? ' error ' : '')
                          "
                        />

                        <IconButton
                          color="tertiary"
                          @click="changeRandomEmail()"
                          size="small"
                          class="circle rentagle-button"
                          icon="rentagle"
                        ></IconButton>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="row row-mob align-items-start">
              <div class="three-select-student-add">
                <div class="form__field form__field--single">
                  <div class="form__field-label">השתייכות ארגונית</div>

                  <Select2
                    v-model="form.info.organization_id"
                    :options="organizations"
                  />
                </div>
              </div>
              <div class="three-select-student-add">
                <div class="form__field form__field--single">
                  <div class="form__field-label">רשות</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="רשות"
                    :rules="atLeastOneNotEmpty"
                    vid="district_administrations"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <CustomThreeSelectVue
                      :options="administrations"
                      v-model="form.district_administrations"
                      ref="administrationsRef"
                      :openDirection="'top'"
                      :class="errors[0] ? 'custom-select-error ' : ''"
                    ></CustomThreeSelectVue>
                  </ValidationProvider>
                </div>
              </div>
              <div class="three-select-student-add">
                <div class="form__field form__field--single">
                  <div class="form__field-label">מסגרת</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="תרגסמ"
                    :rules="atLeastOneNotEmpty"
                    vid="institutions"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <CustomThreeSelectVue
                      :options="institutions"
                      ref="institutionsRef"
                      v-model="form.institutions"
                      :multiple="false"
                      :openDirection="'top'"
                      :class="errors[0] ? ' custom-select-error ' : ''"
                    ></CustomThreeSelectVue>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="row row-mob align-items-start new-select-block">
              <div class="select-student-add">
                <div class="form__field form__field--single">
                  <div class="form__field-label">קבוצה</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="קבוצה"
                    vid="info.student_group_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="form.info.student_group_id"
                      :options="groups"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="select-student-add">
                <div class="form__field">
                  <div class="form__field-label">כיתה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="כיתה"
                    vid="info.student_class_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="form.info.student_class_id"
                      :options="classes"
                      :class="errors[0] ? ' select-error ' : ''"
                      @change="setDateEnd()"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="send-message_block">
          <span
            v-if="
              $perm(
                'security.view_proptech_selfenrollment_link',
                currentUser?.campus_id
              )
            "
          >
            העלה נתונים למערכת זיהוי
          </span>
          <CheckBoxModalVue
            v-if="
              $perm(
                'security.view_proptech_selfenrollment_link',
                currentUser?.campus_id
              )
            "
            :check="sendToProptech"
            @checkedElem="checkedElemProptech"
          ></CheckBoxModalVue>
          <span>לשלוח למשתמש פרטי כניסה לאזור האישי</span>
          <CheckBoxModalVue
            :check="sendMessage"
            @checkedElem="checkedElem"
          ></CheckBoxModalVue>
        </div>
        <div class="popup__footer_student-add">
          <button
            class="btn btn--green btn--static-lg"
            @click.prevent="sendData"
          >
            <icon name="save-block" />
            שמור
          </button>
          <button
            class="btn btn--border-grey btn--static-lg"
            @click="$emit('close')"
          >
            בטל
          </button>
        </div>
      </ValidationObserver>
    </div>
  </modal>
</template>

<script>
// Packages
import axios from 'axios';
import moment from 'moment';
import * as lang from 'vuejs-datepicker/src/locale';
import vDatepicker from '@/Components/UI/Form/vDatePicker';
// Validation
import { extend, setInteractionMode, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules.js';
import Lang from 'vee-validate/dist/locale/he.json';
import UploadImage from '@/Components/UI/Form/UploadImage';
import CustomThreeSelectVue from '@/Components/UI/Form/CustomThreeSelect.vue';
import IconButton from '@/Components/UI/Buttons/IconButton.vue';
import CheckBoxModalVue from '@/Components/UI/Form/CheckBoxModal.vue';
import { mapGetters } from 'vuex';

const messages = Lang.messages;

setInteractionMode('passive');
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

export default {
  name: 'StudentAdd',
  components: {
    ValidationObserver,
    CustomThreeSelectVue,
    vDatepicker,
    UploadImage,
    IconButton,
    CheckBoxModalVue
  },
  props: {
    instForFilterSchool: {
      type: Array
    },
    selectedCampus: {
      required: true
    },
    statusId: {
      type: Number,
      default: 1
    },
    selectedInst: {
      type: [Number, String]
    }
  },
  data() {
    return {
      sendMessage: true,
      sendToProptech: false,
      page: 'StudentModalAdd',
      edit: this.$route.params.id ? 1 : 0,
      activeTab: 1,
      language: lang,
      show_aditional: true,
      sexValues: [
        {
          id: 'male',
          text: 'זכר'
        },
        {
          id: 'female',
          text: 'נקבה'
        }
      ],
      groups: [],
      classes: [],
      statuses: [],
      organizations: [],
      campuses: [],
      actual_citizenships: [],
      additional_citizenships: [],
      administrations: [],
      institutions: [],
      countries: [],
      imagePreview: '',
      imageNotValid: false,
      imageError: 'העלה תמונה',
      periodNotValid: false,
      periodError: 'חובה למלא את השדה תקופת הלימודים',
      setNewBirthday: null,
      form: {
        institutions: [this.selectedInst],
        district_administrations: [],
        main: {
          name: '',
          last_name: '',
          photo: '',
          img: '',
          email: '',
          mobile: '',
          campus_id: this.selectedCampus.id,
          sex: '',
          citizenship_id: '',
          additional_citizenship_id: '',
          phone: '',
          person_number: '',
          birthday: '',
          address: '',
          country_id: '',
          foreign_passport_number: '',
          comment: ''
        },
        info: {
          organization_id: '',
          // administrations: [],
          // institutions: [],
          study_start: moment(new Date()).format('YYYY-MM-DD'),
          study_end: '',
          student_status_id: this.statusId,
          student_group_id: '',
          student_class_id: ''
        }
      },
      loaderImg: false,
      avatarImgLoaded: false,
      otherUploadPercentage: 0
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),
    atLeastOneNotEmpty() {
      return {
        required:
          this.form.district_administrations.length === 0 &&
          this.form.institutions.length === 0
      };
    }
  },
  watch: {
    // selectedInst(val) {
    //   axios
    //     .get('/api/campus-classes/' + this.selectedCampus.id, {
    //       params: {
    //         institution_id: newValue
    //       }
    //     })
    //     .then(res => {
    //       this.classes = res.data.data;
    //     });
    //   axios
    //     .get('/api/campus-groups/' + this.selectedCampus.id, {
    //       params: {
    //         institution_id: newValue
    //       }
    //     })
    //     .then(res => {
    //       this.groups = res.data.data;
    //     });
    // },
    // Наблюдение за institutions в form
    'form.institutions': {
      handler(newValue, oldValue) {
        axios
          .get('/api/campus-classes/' + this.selectedCampus.id, {
            params: {
              institution_id: newValue
            }
          })
          .then(res => {
            this.classes = res.data.data;
          });
        axios
          .get('/api/campus-groups/' + this.selectedCampus.id, {
            params: {
              institution_id: newValue
            }
          })
          .then(res => {
            this.groups = res.data.data;
          });
        // Ваш код обработки изменения institutions
      },
      deep: true // Это необходимо для наблюдения за изменениями внутри массива или объекта
    }
  },
  created() {
    if (!this.$perm('student.create')) {
      this.$router.replace('/');
    }
    axios.get('/api/citizenships').then(res => {
      this.actual_citizenships = res.data.data;
    });
    axios.get('/api/countries').then(res => {
      this.countries = res.data.data;
    });

    // axios
    //   .get('/api/main-info/institutions', {
    //     params: {
    //       short: 1
    //     }
    //   })
    //   .then(res => {
    //     const array = res.data.data.map(el => {
    //       return { ...el, label: el.title };
    //     });
    //     this.institutions = array;
    //     if (this.institutions.length === 1) {
    //       this.form.institutions = [this.institutions[0].id];
    //     }
    //     console.log(this.selectedInst, 'inst modal');
    //   });
    this.institutions = this.instForFilterSchool.map(el => {
      return { ...el, label: el.title };
    });
    if (this.institutions.length === 1) {
      this.form.institutions = [this.institutions[0].id];
      if (this.form.institutions == 0 || this.form.institutions) {
        axios
          .get('/api/campus-classes/' + this.selectedCampus.id, {
            params: {
              institution_id: newValue
            }
          })
          .then(res => {
            this.classes = res.data.data;
          });
        axios
          .get('/api/campus-groups/' + this.selectedCampus.id, {
            params: {
              institution_id: newValue
            }
          })
          .then(res => {
            this.groups = res.data.data;
          });
      }
    }
    axios
      .get('/api/main-info/district-administration', {
        params: {
          short: 1
        }
      })
      .then(res => {
        const array = res.data.data.map(el => {
          return { ...el, label: el.title };
        });
        this.administrations = array;
        if (this.administrations.length === 1) {
          this.form.district_administrations = [this.administrations[0].id];
        }
      });

    axios.get('/api/campuses').then(res => {
      this.campuses = res.data.data;
      if (this.campuses && this.campuses.length == 1 && this.campuses[0]) {
        this.form.main.campus_id = this.campuses[0].id;
        this.selectCampus(this.campuses[0].id);
      }
    });
    axios.get('/api/statuses').then(res => {
      this.statuses = res.data.data;
      this.form.info.student_status_id = this.statusId;
    });
    axios.get('/api/organizations').then(res => {
      this.organizations = res.data.data;
      const null_value = {
        id: 0,
        text: '-'
      };
      this.organizations.unshift(null_value);
    });
    axios
      .get('/api/campus-classes/' + this.selectedCampus.id, {
        params: {
          institution_id: this.selectedInst
        }
      })
      .then(res => {
        this.classes = res.data.data;
      });
    axios
      .get('/api/campus-groups/' + this.selectedCampus.id, {
        params: {
          institution_id: this.selectedInst
        }
      })
      .then(res => {
        this.groups = res.data.data;
      });
  },
  methods: {
    checkedElem() {
      this.sendMessage = !this.sendMessage;
    },
    checkedElemProptech() {
      this.sendToProptech = !this.sendToProptech;
    },
    async sendMessageLogin(user) {
      try {
        const respons = await axios.post('/api/send-user-credentials', {
          email: this.form.main.email,
          user_type: 'student'
        });
      } catch (error) {
        console.log(error);
      }
    },
    async changeRandomEmail() {
      event.preventDefault();
      try {
        const respons = await axios.get('/api/user-generate-email');
        this.form.main.email = respons.data.email;
      } catch (error) {
        console.log(error);
      }
    },
    changeBirthdayDate(date) {
      this.form.main.birthday = date;
    },
    disabledRange(date) {
      return date > new Date();
    },
    changeTab(value) {
      this.activeTab = value;
    },
    getAdditionalCitizenships(event) {
      this.form.main.additional_citizenship_id = 0;
      axios.get('/api/additional-citizenships/' + event).then(res => {
        this.additional_citizenships = res.data.data;
      });
    },
    selectCampus(event) {
      this.form.info.student_class_id = '';
      this.form.info.student_group_id = '';
      // axios.get('/api/campus-classes/' + event).then(res => {
      //   this.classes = res.data.data;
      // });
      // axios.get('/api/campus-groups/' + event).then(res => {
      //   this.groups = res.data.data;
      // });
    },
    selectFile(event) {
      this.loaderImg = true;
      this.avatarImgLoaded = false;
      this.otherUploadPercentage = 0;
      this.form.main.photo = event.target.files[0];
      const formData = new FormData();
      formData.append('img', this.form.main.photo);
      axios
        .post('/api/user-photo-store', formData, {
          headers: {
            accept: 'application/json',
            'Content-Type': 'multipart/form-data;'
          },
          onUploadProgress: function (progressEvent) {
            const progress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            this.otherUploadPercentage = progress;
          }.bind(this)
        })
        .then(res => {
          this.imagePreview = res.data;
          this.form.main.img = res.data;
          this.imageNotValid = false;
          this.$toastr.s('תמונה הועלתה');
        })
        .catch(err => {
          this.$toastr.e(err.response?.data?.message || 'שגיאה');
        })
        .finally(() => {
          this.loaderImg = false;
          this.avatarImgLoaded = true;
        });
    },
    // setBirthday(date) {
    //   this.form.main.birthday = this.$convertDate(date);
    // },
    async sendData() {
      const valid = await this.$refs.observer.validate();
      console.log(valid);
      if (this.institutions.length === 0) {
        this.periodNotValid = true;
        this.periodError = 'institutions';
        return;
      }
      if (!this.form.info.study_start) {
        this.periodNotValid = true;
      } else {
        this.periodNotValid = false;
      }
      if (this.imageNotValid || this.periodNotValid) {
        return;
      }
      if (!Array.isArray(this.form.institutions)) {
        this.form.institutions = [this.form.institutions];
      }
      if (valid) {
        axios
          .post('/api/students', this.form)
          .then(async res => {
            this.$toastr.s('נשמר');
            console.log(this.sendMessage, 'this.sendMessage');
            if (this.sendMessage) {
              this.sendMessageLogin();
            }
            // Если выбран чекбокс, добавляем пользователя в PropTech
            if (this.sendToProptech && res.data.user_id) {
              // Получаем entity_id из ответа API, если есть user
              let entityId = null;
              if (res.data.user && res.data.user.entity_id) {
                entityId = res.data.user.entity_id;
              } else if (res.data.user_id) {
                // Если user не загружен в ответе, делаем запрос для получения entity_id
                try {
                  const userResponse = await axios.get(
                    `/api/users/${res.data.user_id}`
                  );
                  if (userResponse.data && userResponse.data.entity_id) {
                    entityId = userResponse.data.entity_id;
                  }
                } catch (e) {
                  console.error('Error fetching user:', e);
                }
              }

              await this.addUserToProptech(res.data.user_id, entityId);
            }
            this.$router.push({
              name: 'StudentEdit',
              params: { id: res.data.id }
            });
          })
          .catch(err => {
            this.show_aditional = true;

            const errors = err.response.data.errors;
            if (errors) {
              this.$refs.observer.setErrors(errors);
              if (errors['main.img']) {
                this.imageNotValid = true;
                this.imageError = errors['main.img'][0];
              }
              if (errors['info.study_end']) {
                this.periodNotValid = true;
                this.periodError = errors['info.study_end'][0];
              }
              if (errors['info.study_start']) {
                this.periodNotValid = true;
                this.periodError = errors['info.study_start'][0];
              }
              // if (errors['info.institution']) {
              //   this.periodNotValid = true;
              //   this.periodError = errors['info.institution'][0];
              // }
            } else {
              this.$toastr.e('שגיאה');
            }
          });
      } else {
        this.show_aditional = true;
      }
    },
    setDateEnd() {
      if (this.form.info.student_class_id) {
        const st_class = this.classes.find((element, index, array) => {
          if (element.id == this.form.info.student_class_id) {
            return element;
          }
        });
        const date_start = new Date(this.form.info.study_start);
        const now = new Date();
        const level = st_class.level ? st_class.level.level : 12;
        let date_end = null;
        if (now.getMonth() > 6) {
          const year = now.getFullYear() + (12 - level) + 1;
          const date_string = year + '-06-30';
          date_end = new Date(date_string);
        } else {
          const year = now.getFullYear() + (12 - level);
          const date_string = year + '-06-30';
          date_end = new Date(date_string);
        }
        this.form.info.study_end = date_end;
      }
    },
    setDateStart(date) {
      this.form.info.study_start = date;
    },
    async addUserToProptech(userId, entityId = null) {
      try {
        // Формируем имя пользователя
        let userName = this.form.main.name || '';
        if (this.form.main.name && this.form.main.last_name) {
          userName = `${this.form.main.name} ${this.form.main.last_name}`;
        }

        const userData = {
          id: userId.toString(),
          name: userName
        };

        // Добавляем опциональные поля, если они есть
        if (this.form.main.email) {
          userData.email = this.form.main.email;
        }
        // Добавляем entity_id, если он передан
        if (entityId) {
          userData.entity_id = entityId;
        }

        const response = await axios.post(
          '/api/proptech/create-person',
          userData
        );

        if (response.status === 200) {
          this.$toastr.s('המשתמש נוסף למערכת PropTech בהצלחה');

          // Отправляем ссылку для самостоятельной регистрации
          try {
            await axios.post(
              `/api/proptech/send-self-enrollment-link/${userId}`
            );
          } catch (enrollmentError) {
            console.error(
              'Error sending self-enrollment link:',
              enrollmentError
            );
            // Не показываем ошибку пользователю, так как пользователь уже создан
          }
        }
      } catch (error) {
        console.error('Error adding user to PropTech:', error);
        const errorMessage =
          error.response?.data?.message ||
          'שגיאה בהוספת המשתמש למערכת PropTech';
        this.$toastr.e(errorMessage);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .popup {
  border-radius: 8px;
}
::v-deep .popup__header {
  border-radius: 8px;
}
::v-deep .popup__header-inner {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
::v-deep .popup__footer_student-add {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
::v-deep
  .form__field
  .select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  background-image: url(../../../img/arrow-drop-down.svg) !important;
}
::v-deep
  .form__field
  .select2-container[dir='rtl']
  .select2-selection--single
  .select2-selection__arrow {
  left: 12px;
}
.new-select-block {
  padding-left: 7px;
}
::v-deep .custom-select .vue-treeselect__single-value {
  padding-top: 0px !important;
  padding-right: 0px !important;
  font-size: 14px;
  font-weight: 500;
}
.send-message_block {
  width: 100%;
  height: 64px;
  padding: 16px 16px 24px 16px;
  display: flex;
  gap: 8px;
  flex-direction: row-reverse;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
}
.email-form__field-input {
  width: 87%;
  border: none;
  background-color: transparent;
  &:hover {
    // background: #409fff;
    // border-color: #409fff;
    // stroke: #fff;
    // box-shadow: 0px 6px 10px rgba(9, 131, 255, 0.5);
  }
  &:focus {
    border: none !important;
  }
}

.input_email-block {
  // border: 1px solid #cfd3de;
  // line-height: 38px;
  // width: 100%;
  // border-radius: 4px;
  // padding: 0 8px;
  // transition: 0.3s;
  // font-size: 14px;
  // appearance: none;
  // background-color: transparent;
  // font-family: 'Rubik', sans-serif;
  position: relative;
  display: flex;
  .rentagle-button {
    position: absolute;
    left: 0;
  }
}
.custom-select-error {
  border: 1px solid #ff5040;
  border-radius: 4px;
}
::v-deep .vue-treeselect__limit-tip-text {
  margin: 6px 0px 0 0 !important;
}
::v-deep .vue-treeselect__input-container {
  margin-top: 4px !important;
}

::v-deep .custom-select .vue-treeselect__control {
  height: 40px;
  border: 1px solid #cfd3de;
  border-radius: 4px;
  padding: 0 12px;
  background: none;
}
::v-deep .vue-treeselect__x-container {
  // padding-left: 24px;
  // padding-bottom: 1px;
  display: none;
}
.popup__footer_student-add {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  padding-top: 16px;
  background-color: #ebeef5;
  gap: 8px;
}
.three-select-student-add {
  position: relative;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  margin-bottom: 0;
  flex: 0 0 33%;
  max-width: 33%;
}
.select-student-add {
  position: relative;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  margin-bottom: 0;
  flex: 0 0 50%;
  max-width: 50%;
}
</style>
